<img [src]="image" class="w-full h-full border-round-md" style="object-fit: fill" />
